module.exports = __webpack_public_path__ + "media/images/workplace/banners/uhrs_job_banner_variant4_image-45a2b75e92cdfbe5f4c80ab848430328.jpg";